import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

interface StepFormContentProps extends React.HTMLAttributes<HTMLDivElement> {}

export const StepFormContent = forwardRef<HTMLDivElement, StepFormContentProps>(
  ({ hidden, children, className, ...restProps }, ref) => {
    if (hidden) {
      return null;
    }

    return (
      <div ref={ref} className={twMerge('flex-1', className)} {...restProps}>
        {children}
      </div>
    );
  },
);

StepFormContent.displayName = 'StepFormContent';
